import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Icons,
  Input,
} from '@ais-ui/ui-core';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { useLogin } from './LoginProvider';
import { tryLogin } from './authHelpers';
import { useState } from 'react';

const FormSchema = z.object({
  username: z.string().min(2, {
    message: 'Username must be at least 2 characters.',
  }),
  password: z.string(),
});

export function LoginCard() {
  const { login, setShowLogin, showLogin } = useLogin();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      username: '',
      password: '',
    },
  });

  const handleSubmit = async (data: z.infer<typeof FormSchema>) => {
    setIsLoading(true);
    if (await tryLogin(data)) {
      login(data);
    } else {
      form.setError('root', {
        type: 'custom',
        message: 'Wrong username or password!',
      });
    }
    setIsLoading(false);
  };
  return (
    <Dialog open={showLogin} onOpenChange={setShowLogin}>
      <DialogContent className="sm:max-w-[425px]">
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(handleSubmit)}
            id="login"
            className="w-full space-y-4"
          >
            <DialogHeader className="text-center py-1 my-2">
              <DialogTitle className="text-2xl">
                Login to your account
              </DialogTitle>
              <DialogDescription>
                Enter your account details below to login
              </DialogDescription>
            </DialogHeader>
            <FormField
              control={form.control}
              name="username"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Username (E-mail)</FormLabel>
                  <FormControl onChange={() => form.clearErrors()}>
                    <Input
                      type="text"
                      placeholder="Username"
                      className="rounded"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="password"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Password</FormLabel>
                  <FormControl onChange={() => form.clearErrors()}>
                    <Input
                      type="password"
                      placeholder="Password"
                      className="rounded"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            {form.formState.errors.root && (
              <div className="text-red-500">
                {form.formState.errors.root.message}
              </div>
            )}
          </form>
        </Form>
        <DialogFooter>
          <Button
            type="submit"
            form="login"
            variant={'oceanio'}
            className="w-full"
            disabled={!form.getValues().username || !form.getValues().password}
          >
            {isLoading && (
              <Icons.spinner className="mr-2 size-4 animate-spin" />
            )}
            SIGN IN
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
